export default "__VITE_ASSET__BCvEhZ3X__"